export default __webpack_public_path__ + "static/media/documents_region_Y_combinator.78b049dd.svg";